import Spinner from "../shared/UxbiSpinner";
import React, { useState } from "react";
import { Form, Button, Alert, InputGroup } from "react-bootstrap";
import { Eye, EyeOff, ArrowRight, ShieldCheck, Mail, Lock } from "lucide-react";
import { useSession } from "./SessionProvider";
export default function Login() {
  const { login, error, reload } = useSession();
  const [email, setEmail] = useState(""),
    [password, setPassword] = useState(""),
    [show, setShow] = useState(false),
    [busy, setBusy] = useState(false),
    [failure, setFailure] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setFailure("");
    try {
      await login({ email, password });
    } catch (e) {
      setFailure(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="login-page">
      <div className="login-story">
        <span className="eyebrow">PIEDRAS VIVAS</span>
        <h1>
          Tu operación comercial,
          <br />
          en un mismo lugar.
        </h1>
        <p>
          Conecta tus oportunidades con tus ventas.
          <br />
          Mantén a la vista lo que sigue.
        </p>
        <small>
          <ShieldCheck size={17} /> Información conectada a tu ERP
        </small>
      </div>
      <div className="login-panel">
        <Form onSubmit={submit}>
          <div className="login-logo">
            <img src="/uxbi-logo.svg" alt="UXBI" />
          </div>
          <div className="login-heading">
            <span className="eyebrow">BIENVENIDO</span>
            <h2>Inicia sesión</h2>
            <p>Accede al espacio de tu negocio.</p>
          </div>
          {(failure || error) && (
            <Alert variant="danger">
              {failure || error}
              {localStorage.getItem("authToken") && (
                <Button variant="link" onClick={reload}>
                  Reintentar conexión
                </Button>
              )}
            </Alert>
          )}
          <Form.Label htmlFor="email">Correo electrónico</Form.Label>
          <InputGroup className="login-input">
            <InputGroup.Text>
              <Mail size={18} aria-hidden="true" />
            </InputGroup.Text>
            <Form.Control
              id="email"
              placeholder="ejemplo@correo.com"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </InputGroup>
          <Form.Label className="mt-4" htmlFor="password">
            Contraseña
          </Form.Label>
          <InputGroup className="login-input">
            <InputGroup.Text>
              <Lock size={18} aria-hidden="true" />
            </InputGroup.Text>
            <Form.Control
              id="password"
              placeholder="Escribe tu contraseña"
              type={show ? "text" : "password"}
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="password-toggle"
              aria-pressed={show}
              aria-label={show ? "Ocultar contraseña" : "Mostrar contraseña"}
              onClick={() => setShow(!show)}
            >
              {show ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </InputGroup>
          <Button className="login-submit" type="submit" disabled={busy}>
            {busy ? (
              <Spinner size="sm" />
            ) : (
              <>
                Entrar <ArrowRight size={18} />
              </>
            )}
          </Button>
          <small className="login-note">UXBI · Piedras Vivas</small>
        </Form>
      </div>
    </div>
  );
}
